import { ChecklistTemplateType } from '@/shared/model/checklistTemplate.model'
import { createResource } from '../utils/resource'

const checklistStore = createResource('report', {})

const enhancedChecklistStore = {
    ...checklistStore,

    actions: {
        ...checklistStore.actions,
    },

    getters: {
        ...checklistStore.getters,

        checklistReports(state: any) {
            if (!state.items) return []
            return state.items.filter((report: any) => 
                report?.checklistTemplate?.type === ChecklistTemplateType.CHECKLIST
            )
        }
    }
}

export default enhancedChecklistStore
